<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    /**
     * Determines if the component is automatically positioned
     * in the app in the bottom right corner
     */
    autoPositioned: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup () {
    return {
      gitTag: GIT_VERSION,
      gitHash: GIT_HASH,
      gitBranch: GIT_BRANCH
    }
  }
})
</script>

<template>
  <transition appear name="version-info">
    <aside v-if="true" :class="{ 'auto-positioned': autoPositioned }">v{{ gitTag }} {{ gitHash }} {{ gitBranch }}</aside>
  </transition>
</template>

<style lang="scss" scoped>
aside {
  padding: 2px 4px;
  background-color: #000;
  color: #fff;
  font-size: 0.5rem;
  font-weight: bold;

  &.auto-positioned {
    position: fixed;
    z-index: 10000;
    right: 0;
    bottom: 0;
  }
}

.version-info-enter-active,
.version-info-leave-active {
  transition: transform 0.3s ease-in-out;
}

.version-info-enter-from,
.version-info-leave-to {
  transform: translate3d(100%, 0, 0);
}
</style>
